import { useState } from 'react';
import mondaySdk from 'monday-sdk-js';
import { type ColumnSettingsFieldValue } from '@gorilla/portal-shared/src/schemas';
import { type ColumnSettingsFieldDescriptor } from '@gorilla/portal-shared/src/types';
import { type Board as BoardType } from '@gorilla/common/src/lib/monday-api/api';
import { Box, Flex, Icon, IconButton, Text } from '@vibe/core';
import { Board, ExternalPage } from '@vibe/icons';
import { ColumnSettings } from '../ColumnSettings';

type ColumnSettingsClientsBoardFieldProps = {
  value: ColumnSettingsFieldValue;
  clientBoard: BoardType;
  fieldDescriptor: ColumnSettingsFieldDescriptor;
  onChange: (value: ColumnSettingsFieldValue) => void;
  screenMode: 'small' | 'medium' | 'large';
  isOpen: boolean;
};

export function ColumnSettingsClientsBoardField({
  value,
  clientBoard,
  fieldDescriptor,
  onChange,
  screenMode,
  isOpen,
}: ColumnSettingsClientsBoardFieldProps) {
  const monday = mondaySdk();
  const [isClientsBoard, setIsClientsBoard] = useState<boolean>(true);

  return (
    <>
      <Box
        className="section__field section__field--boardsource__clientsboard"
        border={true}
        borderColor="layoutBorderColor"
        backgroundColor="greyBackgroundColor"
        style={{
          borderTopRightRadius: '4px',
          borderTopLeftRadius: '4px',
        }}
      >
        <Box padding="medium">
          <Flex
            gap={16}
            style={{
              width: '100%',
              maxWidth: '100%',
            }}
          >
            <Flex
              gap={8}
              style={{
                flex: 1,
                maxWidth: 'calc(100% - 48px)',
              }}
            >
              <div>
                <Icon
                  icon={Board}
                  size={24}
                  style={{
                    transform: 'translate3d(0,1px,0)',
                  }}
                />
              </div>
              <Text type="text1" weight="bold" align="start" ellipsis={true} withoutTooltip>
                {clientBoard.id ? clientBoard.name : 'Clients Board'}
              </Text>
            </Flex>
            <Box style={{ overflow: 'visible', marginLeft: 'auto' }}>
              <Flex>
                <div
                  style={{
                    pointerEvents: 'none',
                    opacity: 0,
                  }}
                >
                  <IconButton icon={Board} kind="secondary" size="small" color="primary" onClick={() => {}} />
                </div>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
      <Box
        border={true}
        borderColor="layoutBorderColor"
        className="section__field section__field--nomargin column--settings--wrapper section_level_5____"
      >
        {isOpen ? (
          <ColumnSettings
            board={clientBoard}
            columnSettings={value || {}}
            showEditItemValueButton={!!fieldDescriptor.supportsEditingValues}
            onChange={(newColumnSettings) => {
              onChange(newColumnSettings);
            }}
            screenMode={screenMode}
            isDisplayOrderAutoWidth={isClientsBoard}
            mode="clientitem"
          />
        ) : null}
      </Box>
    </>
  );
}
